import {updateFactory} from '@modifi/redux'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const client = getAuthenticatedAdminAresClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.modules?.splitTransaction,
  actionNamePrefix: `transactions/split-transaction`,
  submitRequest: (a, params) => async dispatch => {
    const {transactionId, changes} = params
    const {comment, ...splits} = changes
    const parts = Object.keys(splits).map(key => splits[key])
    dispatch(a.pendingAction())
    let result
    try {
      result = await client.BankTransactions.split({
        transactionId,
        parts,
        comment,
      }).then(res => res.data().bankTransactions)
    } catch (e) {
      dispatch(a.errorAction(e))
      throw e
    }
    dispatch(a.successAction())
    return result
  },
})

export default reducer

export const {
  selectUpdateErrorMessage: selectSplitErrorMessage,
  selectUpdatePending: selectSplitPending,
} = selectors

export const {aSubmit: aSplitTransaction, aReset: aCleanupSplit} = actions
